import React from 'react';
import ListItemLink from 'components/Common/ListItemLink/ListItemLink';

const Header = () => (
  <div className="row">
    <nav className="navbar navbar-fixed-top navbar-default navbar-header_center navbar-toggle_abs">
      <div className="container">
        <div className="navbar-header">
          <a href="/" className=" hidden-xs navbar-brand">
            Logo
          </a>
        </div>
        <div className="collapse navbar-collapse">
          <ul className="nav navbar-nav navbar-right">
            <ListItemLink to={'/account'}>Войти</ListItemLink>
          </ul>
          <ul className="nav navbar-nav navbar-right">
            <ListItemLink exact="true" to={'/'}>
              Главная
            </ListItemLink>
            <ListItemLink to={'/spec'}>Информационный раздел</ListItemLink>
            <ListItemLink to={'/help'}>Помощь</ListItemLink>
          </ul>
        </div>
      </div>
    </nav>
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutLandingPage/Header/Header.js